export enum LoginSource {
    LOCAL = "local",
    GOOGLE = "google",
    FACEBOOK = "facebook",
    SHARE_INDIA = "shareIndia",
    SWASTIKA = "swastika",
    MASTERTRUST = "masterTrust",
    PESB = "pesb",
    STRATX = "stratX"
}

export enum AutoPayState {
    ON = 'ON',
    OFF = 'OFF',
    NULL = '--'
}
